<div *ngIf=showLoader>
    <div class="loader-bg"></div>
    <div class="loader-div">
        <div class="loader circle-loader-2"></div>
    </div>
</div>